import styled from "styled-components";

export const MainContentsItem = styled.div`
  width: 100%;
  overflow: auto;
  display: grid;
  grid-template-rows: 1fr auto;
`;

export const MainContentsItemLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DataHeadBox = styled.div`
  color: ${(props) => props.theme.colors.primary};

  & > div {
    display: flex;
    padding-left: 6px;
    font-size: 1.5rem;
    font-weight: 700;
    align-items: center;
    gap: 8px;
  }
`;

export const MainContentAccordionLayout = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const MainContentItemBox = styled.div`
  grid-area: IMC;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DataItemBox = styled.div`
  grid-area: IH;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
`;

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 10px 0px 10px 0px;
`;

export const DetailDataItemBoxLayout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 6px;
`;

export const DataListBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 6px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: end;
  padding: 16px;
  margin-top: 20px;

  .small {
    width: 60%;
  }
`;
